// The service is shared by every Selwyn instance, and the admin API answers for one of them at a
// time: the one named by the X-Tenant-ID header (the instance id, as the main API sends it).
// Without it every page showed the rows with no tenant, left from before instancing. The choice is
// kept per browser.

const KEY = 'tenantId';

export const getTenantId = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

export const setTenantId = (id) => {
  try { localStorage.setItem(KEY, id); } catch { /* still applies until the page reloads */ }
};

export const tenantHeaders = () => {
  const id = getTenantId();
  return id === null ? {} : { 'X-Tenant-ID': id };
};
